<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">

            <el-form-item prop="no" class="lable-width" label="dcs编号">
                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.no"></el-input>
            </el-form-item>
            <el-form-item prop="type" class="lable-width" label="数据类型">
                <el-select clearable class="input-width"   v-model="editData.type" filterable placeholder="请选择">
                    <el-option
                            v-for="item in sbtype"
                            :key="item.id"
                            :label="item.v"
                            :value="item.id">
                    </el-option>
                </el-select>
                <!--                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.type"></el-input>-->
            </el-form-item>
            <el-form-item prop="name" class="lable-width" label="dcs名称">
                <el-input class="input-width" placeholder="请输入dcs名称" clearable v-model="editData.name"></el-input>
            </el-form-item>
            <el-form-item prop="inputTitle" class="lable-width" label="控件标题">
                <el-input class="input-width" placeholder="请输入控件标题"  clearable v-model="editData.inputTitle"></el-input>
            </el-form-item>

            <el-form-item prop="inputType" class="lable-width" label="控件类型">
                <el-input class="input-width" placeholder="请输入控件类型" clearable v-model="editData.inputType"></el-input>
            </el-form-item>
            <el-form-item prop="inputUnit" class="lable-width" label="控件单位">
                <el-input class="input-width" placeholder="请输入控件单位" clearable v-model="editData.inputUnit"></el-input>
            </el-form-item>
            <el-form-item prop="dcsWidth" class="lable-width" label="dcs控件宽度">
                <el-input class="input-width" placeholder="请输入dcs控件宽度" clearable v-model="editData.dcsWidth"></el-input>
            </el-form-item>
            <el-form-item prop="inputWidth" class="lable-width" label="控件宽度">
                <el-input class="input-width" placeholder="请输入控件宽度" clearable v-model="editData.inputWidth"></el-input>
            </el-form-item>
            <el-form-item prop="upperBound" class="lable-width" label="上限">
                <el-input class="input-width" placeholder="请输入上限" clearable v-model="editData.upperBound"></el-input>
            </el-form-item>
            <el-form-item prop="lowerBound" class="lable-width" label="下限">
                <el-input class="input-width" placeholder="请输入下限" clearable v-model="editData.lowerBound"></el-input>
            </el-form-item>
            <el-form-item prop="orderNo" class="lable-width" label="排序">
                <el-input class="input-width" placeholder="请输入下限" clearable v-model="editData.orderNo"></el-input>
            </el-form-item>
<!--            <el-form-item prop="lruName" class="lable-width" label="录入人">-->
<!--                <el-input class="input-width" disabled clearable v-model="editData.vc_lruname"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="createTime" class="lable-width" label="录入时间">-->
<!--                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>-->
<!--            </el-form-item>-->

            <!--            <el-form-item  label="是否启用">-->
            <!--                <div style="margin-left: 34px">-->
            <!--                    <el-radio v-model="editData.state" :label="1">启用</el-radio>-->
            <!--                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>-->
            <!--                </div>-->
            <!--            </el-form-item>-->

            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">保存</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{

            editData:{
                type:Object
            }
        },
        data(){
            return{
                zttype:[{
                    id:1,
                    v:'运行中'
                },{
                    id:2,
                    v:'调整中'
                },{
                    id:3,
                    v:'停机'
                },],
                sbtype:[{
                    id:1,
                    v:'温度'
                },{
                    id:2,
                    v:'压力'
                },{
                    id:3,
                    v:'液位'
                },{
                    id:4,
                    v:'瞬时流量'
                },{
                    id:5,
                    v:'累计流量'
                },{
                    id:6,
                    v:'耗电量'
                },{
                    id:7,
                    v:'用汽量'
                }],
                cf:'',
                cffb:false,
                jgsc:'',
                gwcgdata:999,
                bmdata:[],
                cjdata:[],
                bzdata:[],
                gwdata:[
                    //     {
                    //     id:1,
                    //     value:'厂长'
                    // },{
                    //     id:2,
                    //     value:'班长'
                    // },{
                    //     id:3,
                    //     value:'卸料'
                    // },{
                    //     id:4,
                    //     value:'成盐'
                    // },{
                    //     id:5,
                    //     value:'缩合'
                    // },{
                    //     id:6,
                    //     value:'浓缩'
                    // },{
                    //     id:7,
                    //     value:'中控'
                    // },{
                    //     id:8,
                    //     value:'小组长'
                    // },{
                    //     id:9,
                    //     value:'商水班长'
                    // },{
                    //     id:10,
                    //     value:'商水叉车'
                    // },{
                    //     id:11,
                    //     value:'商水操作工'
                    // },
                ],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,
                cycleData:[{
                    id:'Day',
                    lable:'每日'
                },{
                    id:'Week',
                    lable:'每周'
                },{
                    id:'Month',
                    lable:'每月'
                },],
                weekData:[{
                    id:1,
                    name:'星期一'
                },{
                    id:2,
                    name:'星期二'
                },{
                    id:3,
                    name:'星期三'
                },{
                    id:4,
                    name:'星期四'
                },{
                    id:5,
                    name:'星期五'
                },{
                    id:6,
                    name:'星期六'
                },{
                    id:7,
                    name:'星期七'
                },],
                monthData:[],
                consumername:[],
                datatimes:[],
                templateData:[],
                cjpanduan:0,
                bzpanduan:0,
                rules: {
                    // bmName: [
                    //     { required: true, message: '请输入部门', trigger: 'blur' },
                    //
                    // ],
                    // cjName: [
                    //     { required: true, message: '请输入车间', trigger: 'blur' },
                    //
                    // ],
                    //
                    // templateName: [
                    //     { required: true, message: '请输入模板', trigger: 'blur' },
                    //
                    // ],
                    // information: [
                    //     { required: true, message: '请输入信息点', trigger: 'blur' },
                    //
                    // ],
                    //
                    // cycle: [
                    //     { required: true, message: '请输入任务周期', trigger: 'blur' },
                    //
                    // ],
                    //
                    // duration: [
                    //     { required: true, message: '请输入时长', trigger: 'blur' },
                    //
                    // ],



                }
            }
        },
        watch:{
        },
        mounted(){
            // if(this.editData.id!==0){
            //   this.dcsdetail()
            // }
        },
        methods:{
            bmfilter(val){
                // this.editData.bmName=val
                // this.getDepartmentsList(val)
                // console.log(this.editData.bmName)
            },
            // gwfilter(val){
            //     this.getStationsList(val)
            // },
            gwsearch(val){
                // this.editData.sid=val
                // this.getStationsList(val)
            },
            gwchange(val){
                this.editData.station=val
                // console.log(val)
            },
            cjfilter(val){
                // console.log(val)
                // if(this.editData.bmName!==''){
                //     this.getWorkshopsList(val)
                //
                // }

            },
            cfipt(e){
                // if(e==1){
                //     this.cffb=!this.cffb
                //     // this.editData.beginTime
                // }else{
                //     this.cffb=!this.cffb
                //
                // }
                // console.log(e)
            },
            bzfilter(val){

            },
            bmchange(val){
                // this.editData.gid=val
                // if(this.editData.bmName!==''){
                //     // this.getWorkshopsList()
                // }
                // this.editData.cjName=''
                // this.editData.bzName=''
            },
            cjchange(val){
                // this.editData.cid=val

            },
            bzchange(val){
                this.editData.bid=val
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList()
                // }
            },
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                    this.editData.beginTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                this.editData.beginTime=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门


            //岗位


            //模板

            //业务配置保存
            async save() {
                // console.log(this.editData.type)
                // return
                if(!this.editData.type){
                    this.editData.type=0
                }
                if(parseFloat(this.editData.upperBound)!==''&&parseFloat(this.editData.lowerBound)!==''){
                    if(parseFloat(this.editData.upperBound) <= parseFloat(this.editData.lowerBound)){
                        this.$message({
                            message: '下限大于上限，请重新输入',
                            type: 'error'
                        });
                        return
                    }
                }

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    no:this.editData.no,
                    name:this.editData.name,
                    inputTitle:this.editData.inputTitle,
                    inputType:this.editData.inputType,
                    inputUnit:this.editData.inputUnit,
                    upperBound:this.editData.upperBound,
                    lowerBound:this.editData.lowerBound,
                    inputWidth:this.editData.inputWidth,
                    dcsWidth:this.editData.dcsWidth,
                    pid:this.editData.pid,
                    orderNo:this.editData.orderNo,
                    type:this.editData.type
                }
                for(let i in params){
                    if(params[i]===''){
                        delete params[i]
                    }
                }
                // console.log(params)
                // return
                let res = await API.save(params);
                if (res.code == 1) {
                    this.$emit('list')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                    this.editData.beginTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(editData){
//获取对应ID
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData.xfname)

                        // let add1=this.consumername.filter(item=>{
                        //     return  item.name==this.editData.consumerName
                        // })
                        // console.log(add1)
                        // this.editData.consumerId=add1[0].id
                        this.save()
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>